import { useParams, useNavigate, useLocation } from "react-router-dom";

const idCompress = (input: any) => input;
const idDecompress = (input: any) => input;
export type UrlParams = {
  project?: string;
  plan?: string;
  folder?: string;
};

// Removed setHash - now using navigate() for hash changes to trigger React re-renders

const buildUrl = ({ project }: UrlParams) => {
  if (!project) {
    return "/project/calendar";
  }
  return `/project/${project}`;
};
export const useProjectVariables = () => {
  const params = useParams<UrlParams>();
  const { hash } = useLocation();
  const nav = useNavigate();
  const setProjectId = (projectId?: string) => {
    nav(
      buildUrl({
        ...params,
        project: projectId ? idCompress(projectId) : undefined,
      })
    );
  };
  const setTab = (tabName: string | undefined) => {
    // Use navigate to change hash so React Router re-renders with updated location
    const currentPath = window.location.pathname + window.location.search;
    nav(tabName ? `${currentPath}#${tabName}` : currentPath, { replace: true });
  };
  const tab = hash.replace(/^#/, "");

  const { project } = params;
  return {
    ...params,
    tab,
    project: idDecompress(project),
    setProjectId,
    setTab,
  };
};
